module.exports = __webpack_public_path__ + "img/DocumentBlank-Solid.e09941d6.svg";